import React from "react";
import { Link, matchPath, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";
import Button from "../../../components/Button";
import { CartIcon } from "../../../components/Icons";

const CartButton = () => {
	const location = useLocation();
	const { isAuth } = useSelector((state) => state.profile);
	const { totalPrice } = useSelector((state) => state.cart);
	const currentParams = new URLSearchParams(location.search);
	
    const isMobileCartVisible = location.pathname === "/" || matchPath("/menu/:id", location.pathname);

	return (
		<>
            {isAuth &&
                <DesktopWrapper>
                    <Link to={{ pathname: "/cart", search: currentParams.toString() }}>
                        <Button type='primary'>
                            <CartIcon color='#ffffff'/>
                            <p>{totalPrice > 0 ? `${totalPrice} ₽` : 'Корзина'}</p>
                        </Button>
                    </Link>
                </DesktopWrapper>
            }
            {isAuth && isMobileCartVisible &&
                <MobileWrapper visible={totalPrice > 0}>
                    <Link to={{ pathname: "/cart", search: currentParams.toString() }}>
                        <MobileCartButton type='primary'>
                            <CartIcon width='30' height='30' color='#ffffff'/>
                            {totalPrice > 0 && <TotalPrice>{totalPrice} ₽</TotalPrice>}
                        </MobileCartButton>
                    </Link>
                </MobileWrapper>
            }
		</>
	);
}

export default CartButton;

const slideUp = keyframes`
  from { transform: translateY(100px); }
  to { transform: translateY(0); }
`;

const slideDown = keyframes`
  from { transform: translateY(0); }
  to { transform: translateY(100px); }
`;

const DesktopWrapper = styled.div`
	@media (max-width: 798px) {
		display: none;
	}
`;

const MobileWrapper = styled.div`
    display: none;
    @media (max-width: 798px) {
        position: fixed;
        bottom: ${props => props.visible ? '32px' : '-100px'};
        right: 16px;
        display: block;
        padding: 4px;
        background: #ffffff;
        border-radius: 20px;
        animation: ${props => props.visible ? slideUp : slideDown} 0.3s ease-out;
        transition: bottom 0.3s ease-out;
        z-index: 100;
    }
`;

const MobileCartButton = styled(Button)`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    padding: 8px;
    min-width: 60px;
    min-height: 60px;
`;

const TotalPrice = styled.div`
    font-size: 10px;
`;
